import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class RankingDataService {
    getRankingData() {
        return [
            {
                id: 'fast100',
                name: '100 Fastest Growing',
                tag: '100_fastest_growing',
                deprecated: false
            },
            {
                id: 'fast500',
                name: 'Fast 500 Deloitte',
                tag: 'fast_500_deloitte',
                deprecated: false
            },
            {
                id: 'federalcontractors',
                name: 'Federal Contractors',
                tag: 'federal_contractors',
                deprecated: false
            },
            {
                id: 'forbesglobal2000',
                name: 'Forbes Global 2,000',
                tag: 'forbes_global_2000',
                deprecated: false
            },
            {
                id: 'fortune500',
                name: 'Fortune 500',
                tag: 'fortune_500',
                deprecated: false
            },
            {
                id: 'fortune1000',
                name: 'Fortune 1,000',
                tag: 'fortune_1000',
                deprecated: false
            },
            {
                id: 'fundingRoundA',
                name: 'Funding Round - A',
                tag: 'funding_round_a',
                deprecated: true
            },
            {
                id: 'fundingRoundB',
                name: 'Funding Round - B',
                tag: 'funding_round_b',
                deprecated: true
            },
            {
                id: 'fundingRoundC',
                name: 'Funding Round - C',
                tag: 'funding_round_c',
                deprecated: true
            },
            {
                id: 'fundingRoundD',
                name: 'Funding Round - D',
                tag: 'funding_round_d',
                deprecated: true
            },
            {
                id: 'fundingRoundSeed',
                name: 'Funding Round - Seed',
                tag: 'funding_round_seed',
                deprecated: true
            },
            {
                id: 'inc5000',
                name: 'Inc 5,000',
                tag: 'inc_5000',
                deprecated: false
            },
            {
                id: 'linkedinTopStartups2021',
                name: 'LinkedIn Top Startups',
                tag: 'linkedin_top_startups_2021',
                deprecated: false
            },
            {
                id: 'managedServiceProviders',
                name: 'Managed Service Providers (MSPs)',
                tag: 'managed_service_providers',
                deprecated: false
            },
            {
                id: 'publicCompanies',
                name: 'Public Companies',
                tag: 'public_companies',
                deprecated: false
            },
            {
                id: 'saas1000',
                name: 'SaaS 1,000',
                tag: 'saas_1000',
                deprecated: false
            },
            {
                id: 'valueAddedResellers',
                name: 'Value-Added Resellers (VARs)',
                tag: 'value_added_resellers',
                deprecated: false
            }
        ];
    }
}
